<template>
  <v-container fluid>
    <v-form>
      <v-row>
        <v-col cols="12">
          <base-material-card
            color="primary"
            icon="mdi-link-variant"
            inline
            class="px-5 py-3"
            title="Novo Relatório de Vínculo de Conciliação"
          >
            <v-row class="mt-5">
              <v-col cols="12">
                <validation-provider v-slot="{ errors }" rules="required" name="Título">
                  <v-text-field
                    v-model="titulo"
                    label="Título"
                    outlined
                    maxlength="100"
                    autofocus
                    clearable
                    placeholder="Informe um título para o vínculo"
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <validation-provider v-slot="{ errors }" rules="required" name="TUC">
                  <v-select
                    v-model="tucsSelecionadas"
                    label="TUC"
                    :items="tucsDisponiveis"
                    :error-messages="errors"
                    outlined
                    attach
                    chips
                    multiple
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <v-divider />
            <v-row>
              <v-col cols="6">
                <v-card tile>
                  <v-subheader>BDGD</v-subheader>
                  <v-divider />
                  <v-card-text>
                    <v-row>
                      <v-col cols="6">
                        <input-month
                          label="Mês dos dados"
                          :selectedMonth="bdgd.mesBdgd"
                          @monthSelected="(mesBdgd) => (bdgd.mesBdgd = mesBdgd)"
                        />
                      </v-col>
                      <v-col cols="6">
                        <select-bdgd-version
                          label="Versão da BDGD"
                          required
                          :companyId="empresaId"
                          :month="bdgd.mesBdgd"
                          :outlined="false"
                          @bdgdVersionSelected="(bdgdVersaoId) => (bdgd.bdgdVersaoId = bdgdVersaoId)"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="align-center d-flex">
                        <v-checkbox v-model="bdgd.todasSituacoesContabeis" label="Considerar todas as situações contábeis?" />
                        <v-tooltip right max-width="300">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" dense class="mb-1 ml-1" v-on="on">mdi-progress-question</v-icon>
                          </template>
                          <span>
                            Quando habilitado, considera registros com
                            <strong>POS IN ('0', 'PD')</strong>
                            independente da situação contábil.
                            <br />
                            Quando desabilitado, aplica também o filtro
                            <strong>SITCONT = 'AT1'</strong>
                            .
                          </span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card tile>
                  <v-subheader>AIS</v-subheader>
                  <v-divider />
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" style="min-height: 185px !important">
                        <input-month label="Mês dos dados" :selectedMonth="ais" @monthSelected="(mesAIS) => (ais = mesAIS)" />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </base-material-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
            color="primary"
            min-width="100"
            style="float: right"
            class="mr-0 mt-n5"
            :disabled="!podeSalvarRelatorio"
            :loading="loading"
            @click="salvarRelatorio"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
  import dayjs from 'dayjs';
  import VinculoConciliacaoService from '@/services/VinculoConciliacaoService';
  import AisService from '@/services/AisService';
  import SelectBdgdVersion from '@/components/general/SelectBdgdVersion';
  import InputMonth from '@/components/general/InputMonth';
  import routes from '@/store/modules/routes';

  const tucs = [125, 135, 160, 190, 210, 255, 265, 295, 325, 330, 340, 345, 395, 545, 565, 570, 575, 580];

  export default {
    components: {
      SelectBdgdVersion,
      InputMonth
    },
    data: () => ({
      loading: false,
      titulo: null,
      tucsDisponiveis: tucs,
      tucsSelecionadas: [...tucs],
      bdgd: {
        mesBdgd: null,
        bdgdVersaoId: null,
        todasSituacoesContabeis: false
      },
      ais: null
    }),
    computed: {
      empresaId() {
        return this.$store.getters.getCompanyId;
      },
      bdgdVersao() {
        return this.$store.getters.getUserSelectedCompanyBdgdVersion;
      },
      bdgdValida() {
        const { mesBdgd, bdgdVersaoId } = this.bdgd;
        return !!(mesBdgd && bdgdVersaoId);
      },
      aisValida() {
        return !!this.ais;
      },
      podeSalvarRelatorio() {
        return !!(this.titulo && this.tucsSelecionadas.length > 0 && this.bdgdValida && this.aisValida);
      }
    },
    mounted() {
      this.setDataBaseBDGD();
      this.getUltimaDataBaseAIS();
    },
    methods: {
      setDataBaseBDGD() {
        if (!this.bdgdVersao) return;
        const mesBdgd = dayjs(this.bdgdVersao.data_registro).format('YYYY-MM');
        this.bdgd.mesBdgd = mesBdgd;
      },
      getUltimaDataBaseAIS() {
        AisService.getUltimaDataBase(this.empresaId)
          .then(({ data }) => {
            const [year, month] = data.split('-');
            const mesAIS = data ? `${year}-${month}` : null;
            this.ais = mesAIS;
          })
          .catch((err) => {
            this.$toast.error('Erro ao buscar a última data base do AIS.', '', {
              position: 'topRight'
            });
            console.error('Erro:', err);
          });
      },
      async salvarRelatorio() {
        this.loading = true;

        try {
          const relatorio = {
            titulo: this.titulo,
            tucs_selecionadas: this.tucsSelecionadas,
            bdgd: this.bdgd,
            ais: this.ais
          };
          await VinculoConciliacaoService.salvarRelatorio(relatorio);
          this.$toast.success('Vínculo cadastrado com sucesso.', '', {
            position: 'topRight'
          });

          this.$router.push({
            name: routes.state.appRoutes['VINCULO_CONCILIACAO_HISTORICO']
          });
        } catch (e) {
          this.$toast.error('Ocorreu um erro ao cadastrar o vínculo.', '', {
            position: 'topRight'
          });
          console.log(e);
        } finally {
          this.loading = false;
        }
      }
    }
  };
</script>
